export default __webpack_public_path__ + "static/media/investment.c1988ae1.png";